(function ($) {

	var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);

    $(".homeslider").slick({

        infinite: true,
        dots: true,

    });

    var clipboard = new ClipboardJS('.btncopy');

    $(function () {
      $('[data-toggle="tooltip"]').tooltip(
      	{
      	    animated: 'fade',
      	    trigger: 'click'
      	})
    });

    $(function () {
       $(document).on('shown.bs.tooltip', function (e) {
          setTimeout(function () {
            $(e.target).tooltip('hide');
            
            if(!isSafari){
            	$(e.target).click();
            }
            
          }, 1000);
       });
    });

    $(document).on('click', 'a.hrefscroll[href^="#"]', function (event) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top-170
        }, 500);
    });

    
})(jQuery);



